module.exports = __webpack_public_path__ + "img/sign.f6d27c63.svg";